const cleanFAQs = (faqsForSchema: Array<TFaqs>): Array<any> => {
  return (
    faqsForSchema?.map((f) => ({
      '@type': 'Question',
      name: f.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: f.answer
          ?.replace(/<[^>]*>?/gm, '') // 1. Remove tags HTML (<p>, <div>, etc)
          .replace(/&nbsp;/g, ' ') // 2. Substitui espaços não quebráveis por espaços normais
          .replace(/&amp;/g, '&') // 3. Corrige o duplo encoding do '&'
          .replace(/&quot;/g, '"') // 4. Corrige aspas
          .replace(/\s+/g, ' ') // 5. Remove espaços em branco duplicados
          .trim(), // 6. Remove espaços no início e fim
      },
    })) || []
  );
};

export default cleanFAQs;
